const cell = (c, r) => {
  const v = c.value ? c.value(r) : r[c.key];
  return v === null || v === undefined ? "" : String(v);
};

export async function exportExcel(rows, columns, name) {
  const XLSX = await import("xlsx");
  const data = rows.map((r) => Object.fromEntries(columns.map((c) => [c.label, cell(c, r)])));
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Data");
  XLSX.writeFile(wb, `${name}.xlsx`);
}

export async function exportPdf(rows, columns, name, title) {
  const { jsPDF } = await import("jspdf");
  const { default: autoTable } = await import("jspdf-autotable");
  const doc = new jsPDF({ orientation: "landscape" });
  doc.setFontSize(14);
  doc.text(title, 14, 14);
  autoTable(doc, {
    startY: 20,
    head: [columns.map((c) => c.label)],
    body: rows.map((r) => columns.map((c) => cell(c, r))),
    styles: { fontSize: 8 },
    headStyles: { fillColor: [122, 0, 22], textColor: [245, 230, 186] },
  });
  doc.save(`${name}.pdf`);
}
